const RELOAD_MARKER_KEY = "@stale_build_reload";
const RELOAD_WINDOW_MS = 30_000;

const CHUNK_LOAD_ERROR_MESSAGES = [
	"failed to fetch dynamically imported module",
	"error loading dynamically imported module",
	"importing a module script failed",
	"unable to preload css for",
];

export function isChunkLoadError(error: unknown): boolean {
	if (!(error instanceof Error)) {
		return false;
	}
	if (error.name === "ChunkLoadError") {
		return true;
	}
	const message = error.message.toLowerCase();
	return CHUNK_LOAD_ERROR_MESSAGES.some((candidate) =>
		message.includes(candidate)
	);
}

export function requestReloadForStaleBuild(): boolean {
	const previous = Number(sessionStorage.getItem(RELOAD_MARKER_KEY));
	if (previous && Date.now() - previous < RELOAD_WINDOW_MS) {
		return false;
	}
	sessionStorage.setItem(RELOAD_MARKER_KEY, String(Date.now()));
	window.location.reload();
	return true;
}

export function reloadOnStaleChunk<M>(
	load: () => Promise<M>
): () => Promise<M> {
	return () =>
		load().catch((error: unknown) => {
			if (!isChunkLoadError(error) || !requestReloadForStaleBuild()) {
				throw error;
			}
			// Never settles on purpose: the Suspense fallback stays up while the
			// browser replaces the document, so no error screen ever flashes.
			return new Promise<M>(() => {});
		});
}
